/*
 * @Description:
 * @Autor: Godfery
 * @Date: 2022-08-08 14:15:14
 */
import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export default new Router({
  mode: "history",
  // mode:'hash',
  routes: [
    {
      path: "/",
      name: "Home",
      component: () => import("@/page/Home") // 异步组件拆分实现按需加载（在app.js小的情况下不适合拆分）
    },
    {
      path: "/BusinessIntroduction",
      name: "Business-Introduction",
      component: () => import("@/page/BusinessIntroduction") // 异步组件拆分实现按需加载（在app.js小的情况下不适合拆分）
    },
    {
      path: "/ProductIntroduction",
      name: "Product-Introduction",
      component: () => import("@/page/ProductIntroduction")
    },
    {
      path: "/Credpay",
      name: "Credpay",
      component: () => import("@/page/Cyinvest")
    },
    {
      path: "/join",
      name: "Join",
      component: () => import("@/page/Cyproduct")
    }
  ],
  //作用：每次做路由切换时，都会让新的页面在最顶部
  scrollBehavior(to, from, savePosition) {
    return { x: 0, y: 0 };
  }
});

// WEBPACK FOOTER //
// ./src/router/index.js



// WEBPACK FOOTER //
// ./src/router/index.js